import axios from "axios";
import { BASE_URL } from "../utils/constants";

export const loginUser = async (username, password) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/v1/login`, {
      username,
      password,
      app: "Ventas",
    });
    return response.data;
  } catch (error) {
    console.log(error.response ? error.response.data.msg : error.mesaage);
    //return alert("Usuario/Contraseña incorrecto");
  }
};
